import { render } from "./ResetPasswordPage.vue?vue&type=template&id=c79170a0&scoped=true&ts=true"
import script from "./ResetPasswordPage.ts?vue&type=script&lang=ts"
export * from "./ResetPasswordPage.ts?vue&type=script&lang=ts"

import "./ResetPasswordPage.vue?vue&type=style&index=0&id=c79170a0&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c79170a0"]])

export default __exports__